<div class="aprova-select">
  @if (label) {
  <div class="aprova-select__label-box">
    <label
      [for]="id"
      [attr.data-testid]="dataTestid ? 'selectLabel-' + dataTestid : undefined"
      [class]="labelClass"
    >
      {{ label }}
    </label>

    @if (optionalTag) {
    <span class="aprova-select__optional-tag">(opcional)</span>
    }
  </div>
  }

  <div
    class="aprova-select__backdrop"
    [style.display]="isOpen() ? 'block' : 'none'"
    (click)="$event.stopPropagation(); closeMenu()"
  ></div>

  <div
    class="aprova-select__content"
    [class.aprova-select__content--border]="!filled"
    [class.aprova-select__content--filled]="filled"
    [class.aprova-select__content--disabled]="disabled"
    [class.aprova-select__content--error]="hasError"
    [class.aprova-select__content--rounded]="!squared"
    [style.width]="width || 'auto'"
    [style.height]="height || '40px'"
  >
    <button
      type="button"
      [class.aprova-select__content--rounded]="!squared"
      [disabled]="disabled"
      (click)="onHandleMenuOpen()"
    >
      <span class="aprova-select__selected-text">
        {{ selectedLabel }}
      </span>
      <span class="aprova-select__chevron">
        <svg
          class="h-5 w-5 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <ul
      [class.hidden]="!isOpen()"
      class="aprova-select__menu"
      tabindex="-1"
    >
      @for (option of selectOptions; track option.value; let index = $index) {
      <li
        [id]="id + 'option-' + index"
        class="aprova-select__menu-item"
        [class.aprova-select__menu-item--selected]="option.value === control.value"
        [class.aprova-select__menu-item--disabled]="option.disabled"
        (click)="onSelectOption(option)"
      >
        <span class="aprova-select__menu-item-text">
          {{ option.label || option.value }}
        </span>
      </li>
      }
    </ul>
  </div>

  <div class="aprova-select__error-box">
    <div #errorMessageRef>
      <ng-content select="[error-message]"></ng-content>
    </div>

    @if (hasError && !isErrorMessageSlotUsed) {
    <p class="aprova-select__error-message">{{ errorMessageInternal }}</p>
    }
  </div>
</div>
